module.exports = "/assets/footer/rewards/concept.png?t/MR4+G";